import { N, round, ceil } from './helpers.mjs';

export const PLASTERERS = [
  // ====================== PLASTERERS ======================
  {
    slug: 'plaster-skim',
    trade: 'plasterers',
    name: 'Plaster (Skim Coat)',
    blurb: 'Multi-finish skim ~1.5 bags (25kg) per 10m².',
    inputs: [
      { key: 'length', label: 'Wall length', unit: 'm', placeholder: '8' },
      { key: 'height', label: 'Wall height', unit: 'm', placeholder: '2.4' },
    ],
    compute: (v) => {
      const area = N(v.length) * N(v.height);
      return [
        { label: 'Area', value: round(area, 2), unit: 'm²' },
        { label: 'Multi-finish bags', value: ceil(area * 0.15), unit: '25kg bags' },
        { label: 'Bonding (if needed)', value: ceil(area * 0.18), unit: '25kg bags' },
      ];
    },
  },
  {
    slug: 'plasterboard',
    trade: 'plasterers',
    name: 'Plasterboard Sheets',
    blurb: 'Standard 2400×1200mm (2.88m²) board.',
    inputs: [
      { key: 'area', label: 'Total area to board', unit: 'm²', placeholder: '40' },
      { key: 'wastage', label: 'Wastage', unit: '%', placeholder: '10', default: 10 },
    ],
    compute: (v) => {
      const sheets = ceil((N(v.area) / 2.88) * (1 + N(v.wastage) / 100));
      return [
        { label: 'Boards required', value: sheets, unit: 'sheets' },
        { label: 'Drywall screws', value: sheets * 30, unit: 'screws' },
        { label: 'Scrim tape', value: ceil(sheets * 4), unit: 'm' },
      ];
    },
  },

];
